import { render, staticRenderFns } from "./ColumnPriceSell.vue?vue&type=template&id=3b441475"
import script from "./ColumnPriceSell.vue?vue&type=script&lang=js"
export * from "./ColumnPriceSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports